import { useEffect, useState } from 'react';
import { AutomationRuleConditionTypes, ChannelAutomatedReply, ChannelRuleStatus, mapToChannelAutomatedReply } from '../../models/automations.model';
import { ActionLabels, GridStatusLabelVariant, ToasterTexts, appNote, buttonLabels, emptyLabels, pageTitles } from '../shared/constants';
import { ColDef, ValueGetterParams } from 'ag-grid-community';
import { useSelector } from 'react-redux';
import { setHeaderCount, setHeaderTitle } from '../../helpers/header.helper';
import setToast from '../../helpers/toaster.helper';
import { ChannelsGridEmptyIcon, EditIcon, FacebookActiveIcon, GoogleBusinessIcon, InstaActiveIcon, LiveChatConversationCardIcon, PrimayArrowDownwardIcon, PriorityArrowUpIcon, StartIcon, StopIcon, TrashIcon, WhatsappActiveIcon } from '../../icon';
import * as selector from '../../selectors/selectors';
import { UtilityService } from '../../services/UtilityService';
import { AppRoutes } from '../routes/route.path';
import ConfirmDialog from "../shared/confirm-dialog.component";
import { ChannelType } from '../../models/conversations';
import GridComponent from '../shared/grid';
import { ActionsRenderer } from '../shared/grid/actionsRenderer';
import { ChannelConversationService } from '../../services/channels/ChannelConversationService';
import { ChannelAccountModel, ChannelAccountStatus } from '../../models/channels/channels.model';
import { StatusRenderer } from '../shared/grid/statusRenderer';
import { ToasterType } from '../shared/toaster/toaster.model';
import AddRuleComponentChannel from './add-rule.component-channels';
import { Link, useNavigate } from "react-router-dom";
import SelectChannelSideBarComponent from '../channels/select-channel-side-bar-component';
import { ChannelUserService } from "../../services/ChannelUserService";
import LivechatValidationPendingIcon from "../../icons/live-chat-validation-pending-icon.svg";
import LivechatDisconnectedIcon from "../../icons/live-chat-disconnected-icon.svg";
import NoDataComponent from '../conversations/no-data-component';


interface Props {
    SearchInput: string;
    editOptionHandler: (value: any) => void;
    editOption: boolean;
    refreshData?: () => void;
    onGridReady: (params: any) => void;
    runLoader: () => void;
    gridApi: any;
    count?: (value: number) => void;
    handleChannel?: (channel: number) => void;
    handlePage?: (page: any) => void;
    GridRefresh?: boolean
}

const PrivateRuleComponent = (props: Props) => {
    const navigate = useNavigate();
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const Channels: ChannelAccountModel[] = useSelector(selector.Channels)
    const ActiveChannelsTypes: number[] = useSelector(selector.ActiveChannelsTypes)

    const initialChannelOptions = [
        { Label: "Facebook", ChannelType: ChannelType.FACEBOOK, hasSubOptions: Channels?.filter(x => x.ChannelType === ChannelType.FACEBOOK).length >= 1, SubOptions: Channels?.filter(x => x.ChannelType === ChannelType.FACEBOOK).map((x) => { return ({ Label: x.NickName, Active: false, ID: x.ID }) }), ActiveIcon: FacebookActiveIcon, Icon: FacebookActiveIcon, Active: ActiveChannelsTypes.includes(1), SubOptionsOpen: false },
        { Label: "Instagram", ChannelType: ChannelType.INSTAGRAM, hasSubOptions: Channels?.filter(x => x.ChannelType === ChannelType.INSTAGRAM).length >= 1, SubOptions: Channels?.filter(x => x.ChannelType === ChannelType.INSTAGRAM).map(x => { return ({ Label: x.NickName, Active: false, ID: x.ID }) }), ActiveIcon: InstaActiveIcon, Icon: InstaActiveIcon, Active: (ActiveChannelsTypes.includes(2) && !ActiveChannelsTypes.includes(1)), SubOptionsOpen: false },
        { Label: "Livechat", ChannelType: ChannelType.LIVE_CHAT, hasSubOptions: Channels?.filter(x => x.ChannelType === ChannelType.LIVE_CHAT).length >= 1, SubOptions: Channels?.filter(x => x.ChannelType === ChannelType.LIVE_CHAT).map((x) => { return ({ Label: x.NickName, Active: false, ID: x.ID }) }), ActiveIcon: LiveChatConversationCardIcon, Icon: LiveChatConversationCardIcon, Active: (ActiveChannelsTypes.includes(4) && !ActiveChannelsTypes.includes(1) && !ActiveChannelsTypes.includes(2)), SubOptionsOpen: false },
        { Label: "Google Business Messages", ChannelType: ChannelType.GOOGLE_BUSINESS, hasSubOptions: Channels?.filter(x => x.ChannelType === ChannelType.GOOGLE_BUSINESS).length >= 1, SubOptions: Channels?.filter(x => x.ChannelType === ChannelType.GOOGLE_BUSINESS).map(x => { return ({ Label: x.NickName, Active: false, ID: x.ID }) }), ActiveIcon: GoogleBusinessIcon, Icon: GoogleBusinessIcon, Active: false, SubOptionsOpen: false },
        { Label: "Whatsapp", ChannelType: ChannelType.WHATSAPP, hasSubOptions: Channels?.filter(x => x.ChannelType === ChannelType.WHATSAPP).length >= 1, SubOptions: Channels?.filter(x => x.ChannelType === ChannelType.WHATSAPP).map(x => { return ({ Label: x.NickName, Active: false, ID: x.ID }) }), ActiveIcon: WhatsappActiveIcon, Icon: WhatsappActiveIcon, Active: (ActiveChannelsTypes.includes(3) && !ActiveChannelsTypes.includes(1) && !ActiveChannelsTypes.includes(2) && !ActiveChannelsTypes.includes(4)), SubOptionsOpen: false }
    ]

    const [editoption, setEditoption] = useState<boolean>(false);
    const [OperatingRowId, setOperatingRowId] = useState<string>("");
    const [OperatingRule, setOperatingRule] = useState<any>(null);
    const [IsLoading, setIsLoading] = useState<boolean>(false);
    const [IsDeleteInProgress, setIsDeleteInProgress] = useState<boolean>(false);
    const [ShowDeleleConfirmation, setShowDeleteConfirmation] = useState<boolean>(false);
    const [Text, setText] = useState<string>("");
    const [ButtonName, setButtonName] = useState<string>("");
    const [rowData, setRowData] = useState<any>()
    const [columnDefs, setColumnDefs] = useState<any>([])
    const [channelOptions, setChannelOptions] = useState<any[]>(initialChannelOptions);
    const [sidebarWidth, setSidebarWidth] = useState<number>(IsMobileDevice ? 10 : 24);
    const [activeChannel, setActiveChannel] = useState<any>({ Label: "Facebook", ChannelType: ChannelType.FACEBOOK, hasSubOptions: Channels?.filter(x => x.ChannelType === ChannelType.FACEBOOK).length >= 1, SubOptions: Channels?.filter(x => x.ChannelType === ChannelType.FACEBOOK).map((x, index) => { return ({ Label: x.NickName, Active: index === 0 ? true : false, ID: x.ID }) }), Icon: FacebookActiveIcon, Active: true, SubOptionsOpen: true });


    const user = ChannelUserService.getCurrentUserFromLocalStorage();

    useEffect(() => {
        setHeaderTitle(pageTitles.AUTOMATION_RULES);
        setHeaderCount("0 rules")
        return setHeaderTitle
    }, [])

    useEffect(() => {
        if (!!ActiveChannelsTypes.length && !!Channels.length) {
            let initialActiveChannel = initialChannelOptions.find(x => ActiveChannelsTypes.includes(x.ChannelType))
            setChannelOptions(initialChannelOptions.map(x => x.Label === initialActiveChannel.Label ? { Label: initialActiveChannel.Label, ChannelType: initialActiveChannel.ChannelType, hasSubOptions: Channels?.filter(x => x.ChannelType === initialActiveChannel.ChannelType).length >= 1, SubOptions: Channels?.filter(x => x.ChannelType === initialActiveChannel.ChannelType).map((x, index) => { return ({ Label: x.NickName, Active: index === 0 ? true : false, ID: x.ID }) }), Icon: initialActiveChannel.Icon, ActiveIcon: initialActiveChannel.ActiveIcon, Active: true, SubOptionsOpen: true } : x))
            setActiveChannel({ Label: initialActiveChannel.Label, ChannelType: initialActiveChannel.ChannelType, hasSubOptions: Channels?.filter(x => x.ChannelType === initialActiveChannel.ChannelType).length >= 1, SubOptions: Channels?.filter(x => x.ChannelType === initialActiveChannel.ChannelType).map((x, index) => { return ({ Label: x.NickName, Active: index === 0 ? true : false, ID: x.ID }) }), Icon: initialActiveChannel.Icon, ActiveIcon: initialActiveChannel.ActiveIcon, Active: true, SubOptionsOpen: true })
            props.handleChannel(initialActiveChannel.ChannelType)
        }
    }, [Channels, ActiveChannelsTypes])

    useEffect(() => {
        props.handlePage(activeChannel.SubOptions?.find(x => x.Active)?.ID)
    }, [activeChannel])

    useEffect(() => {
        if (props.GridRefresh) {
            refreshData();
        }
    }, [props.GridRefresh])

    useEffect(() => {
        if (!!rowData) {
            setHeaderCount(`${rowData.length} rules`)
            return setHeaderCount
        }
    }, [rowData])


    useEffect(() => {
        if (!!activeChannel && !activeChannel.SubOptions?.find(x => x.Active)) {
            props.runLoader();
            setRowData([])
            props.count(0)
        }
        else {
            props.runLoader();
            setColumnDefs(ChannelColoumnDefs)
            if (Channels.find(x => x.ID === activeChannel.SubOptions?.find(x => x.Active).ID).Status === ChannelAccountStatus.CONNECTED) {
                ChannelConversationService.getAllAutomatedRepliesByPageId(user.OrganizationID, activeChannel.SubOptions?.find(x => x.Active)?.ID).then((res) => {
                    if (res.data !== null) {
                        setRowData(res.data.map(x => mapToChannelAutomatedReply(x)))
                        props.count(res.data.length)
                    }
                    else {
                        setRowData([])
                        props.count(0)
                    }
                }).catch(() => { })
            }
            else {
                setRowData([])
                props.count(0)
            }
        }
    }, [channelOptions])

    const openAddRule = (rowId: string, obj?: ChannelAutomatedReply) => {
        setEditoption(true);
        setOperatingRule(obj);
        setOperatingRowId(rowId);
        props.editOptionHandler(true);
    }

    const closeAddRule = () => {
        setEditoption(false);
        setOperatingRule(undefined);
        setOperatingRowId('');
        props.editOptionHandler(false);
        refreshData()
    };

    const handleChannelDeleteAutomatedReply = (ID: string) => {
        setShowDeleteConfirmation(true);
        setOperatingRowId(ID)
        setText(appNote.AUTO_ALERT_RULE_DELETE);
        setButtonName(buttonLabels.DELETE);
        setIsLoading(false);
    }

    const closeDeleteDialog = (isConfirm: boolean) => {
        if (isConfirm) {
            setIsDeleteInProgress(true);
            ChannelConversationService.deleteAutomatedReplyById(user.OrganizationID, OperatingRowId, activeChannel.ChannelType).then(
                response => {
                    setToast(response.data.message, ToasterType.SUCCESS)
                    setShowDeleteConfirmation(false)
                    if (!!response) {
                        ChannelConversationService.getAllAutomatedRepliesByPageId(user.OrganizationID, activeChannel.SubOptions?.find(x => x.Active).ID).then(res => {
                            setRowData(res.data?.map(x => mapToChannelAutomatedReply(x)))
                            props.count(res.data?.length)
                        })
                    }
                    setIsDeleteInProgress(false);
                    setOperatingRowId("");
                    setOperatingRule(undefined);
                })
                .catch(
                    () => {
                        setToast(ToasterTexts.AUTO_ALERT_RULE_DELETE_FAILED, ToasterType.DANGER)
                        setShowDeleteConfirmation(false)
                        setIsDeleteInProgress(false);
                        setOperatingRowId("");
                        setOperatingRule(undefined);
                    }
                )
        }
        else {
            setShowDeleteConfirmation(false);
            setOperatingRowId("");
            setOperatingRule(undefined);
            setIsDeleteInProgress(false);
        }
    }

    const handleAutomationEnable = (e, ID: string) => {
        setIsLoading(true)
        ChannelConversationService.enableAutomatedReplyById(user.OrganizationID, ID).then(
            response => {
                setToast(response.data.message, ToasterType.SUCCESS, "default")
                if (!!response) {
                    ChannelConversationService.getAllAutomatedRepliesByPageId(user.OrganizationID, activeChannel.SubOptions?.find(x => x.Active).ID).then(res => {
                        setRowData(res.data.map(x => mapToChannelAutomatedReply(x)))
                        props.count(res.data.length)
                    })
                }
            }
        ).catch(() => { })
    }

    const handleAutomationDisable = (e, ID: string) => {
        props.runLoader()
        ChannelConversationService.disableAutomatedReplyById(user.OrganizationID, ID).then(
            (response) => {
                setToast(response.data.message, ToasterType.DANGER, "default")
                if (!!response) {
                    ChannelConversationService.getAllAutomatedRepliesByPageId(user.OrganizationID, activeChannel.SubOptions?.find(x => x.Active).ID).then(res => {
                        setRowData(res.data.map(x => mapToChannelAutomatedReply(x)))
                        props.count(res.data.length)
                    })
                }
            }
        ).catch(() => { })
    }

    const handleDecreasePriorityChange = (ID: string) => {
        props.runLoader()
        ChannelConversationService.DecreaseAutomatedReplyPriority(user.OrganizationID, ID, activeChannel.ChannelType).then(
            response => {
                if (!!response) {
                    ChannelConversationService.getAllAutomatedRepliesByPageId(user.OrganizationID, activeChannel.SubOptions?.find(x => x.Active).ID).then(res => {
                        setRowData(!!res && res.data.map(x => mapToChannelAutomatedReply(x)))
                        props.count(res.data.length)
                    })
                }
            }
        ).catch(
            err => {
                setToast(err, ToasterType.DANGER, 'never')
            }
        )
    }

    const handleIncreasePriorityChange = (ID: string) => {
        props.runLoader()
        ChannelConversationService.IncreaseAutomatedReplyPriority(user.OrganizationID, ID, activeChannel.ChannelType).then(
            response => {
                if (!!response) {
                    ChannelConversationService.getAllAutomatedRepliesByPageId(user.OrganizationID, activeChannel.SubOptions?.find(x => x.Active).ID).then(res => {
                        setRowData(!!res && res.data.map(x => mapToChannelAutomatedReply(x)))
                        props.count(res.data.length)
                    })
                }
            }
        ).catch(
            err => {
                setToast(err, ToasterType.DANGER, 'never')
            }
        )
    }

    const colors = ["#E24D49", "#DD8B0E", "#4276DC", "#878787", "#DEEBFE", "#FA1616", "#CB4954", "#FA8816", "#1616FA", "#7DB34C", "#4863B7", "#69609F", "#BBBD42", "#0A97B0", "#5E7F55", "#40514E", "#C9CCD5", "#878787", "#878787", "#EAE3C8", "#0D0D0D", "#6FD805", "#8816FA", "#038096", "#4A833A", "#4A833A", "#B4ADAD", "#A3D2BD", "#878700"]

    const ChannelColoumnDefs: ColDef[] = [
        {
            field: "Name",
            headerName: "Rule Name",
            valueGetter: (params: ValueGetterParams) => {
                return params.data?.AutomationName
            },
            wrapText: IsMobileDevice ? true : false,
            autoHeight: IsMobileDevice ? true : false,
            resizable: true,
            cellStyle: !IsMobileDevice ? { textOverflow: 'ellipsis', paddingTop: "15px" } : null,
            minWidth: IsMobileDevice ? 70 : 200
        },
        {
            field: "Condition",
            headerName: "Condition",
            valueGetter: (params: ValueGetterParams) => {
                return params.data?.Conditions?.map(x => x.ConditionName === AutomationRuleConditionTypes.GENDER ? "Gender" : x.ConditionName === AutomationRuleConditionTypes.BUSINESS_INFORMATION ? "Business Information" : x.ConditionName === AutomationRuleConditionTypes.KEYWORDS ? "Keywords" : x.ConditionName === AutomationRuleConditionTypes.LOCATION ? "Location" : x.ConditionName === AutomationRuleConditionTypes.MESSAGE_ACTIVITY ? "Message Inactivity" : "Status").join(",")
            },
            wrapText: IsMobileDevice ? true : false,
            autoHeight: IsMobileDevice ? true : false,
            minWidth: IsMobileDevice ? 70 : 200
        },
        {
            field: "KeywordID",
            headerName: "Keyword",
            valueGetter: (params: ValueGetterParams) => {
                return !!params.data.Keywords?.length ? params.data.Keywords?.join(",") : "---";
            },
            wrapText: IsMobileDevice ? true : false,
            autoHeight: IsMobileDevice ? true : false,
            minWidth: IsMobileDevice ? 70 : 200
        },
        {
            field: "Priority",
            headerName: "Priority",
            sort: 'asc',
            valueGetter: (params: ValueGetterParams) => {
                return params.data?.Priority;
            },
            cellRenderer: (params) => {
                return <div className={`d-flex`}>
                    <span className={`px-1 my-auto d-flex c-pointer ${params.data.Priority == 1 ? "opacity-2" : null}`}><PriorityArrowUpIcon onClick={() => params.data.Priority == 1 ? null : handleIncreasePriorityChange(params.data.Id)} /></span>
                    <div className='w-3 h-3 d-flex align-center justify-center br-50 color-secondary h4-regular' style={{ backgroundColor: colors[UtilityService.getHashIndex(!!params.data.AutomationName ? params.data?.AutomationName : "", colors.length)] }}><span className=" my-auto d-flex ">{params.data.Priority > 99 ? "99+" : params.data.Priority}</span></div>
                    <span className={`px-1 c-pointer my-auto d-flex `}><PrimayArrowDownwardIcon onClick={() => handleDecreasePriorityChange(params.data.Id)} /></span>
                </div>
            },
            cellRendererParams: {
                color: 'guinnessBlack'
            },
            minWidth: IsMobileDevice ? 70 : 200

        },
        {
            field: "Status",
            valueGetter: (params: ValueGetterParams) => {
                return params.data?.Status === ChannelRuleStatus.ACTIVE ? "Active" : params.data.Status === ChannelRuleStatus.IN_ACTIVE ? "Inactive" : "Completed"
            },
            cellRendererSelector: params => {
                if (!!params.data) {
                    const label = params.data.Status === ChannelRuleStatus.ACTIVE ? "Active" : "Inactive"
                    const variant = params.data.Status === ChannelRuleStatus.ACTIVE ? GridStatusLabelVariant.Active : GridStatusLabelVariant.Danger;
                    const Status = {
                        component: StatusRenderer,
                        params: {
                            Variant: variant, Label: label, Id: params.data.ID, ClassName: "h5-medium px-2 min-h-3 d-flex align-center"
                        }
                    }
                    return Status;
                }
            },
            headerName: "Status",
        },
        {
            field: "Action",
            maxWidth: 40,
            headerName: "",
            pinned: "right",
            lockPinned: true,
            lockPosition: "right",
            cellClass: "ag-cell-actions-style",
            headerClass: "bg-color-secondary",
            cellRenderer: params => <ActionsRenderer MenuData={[{
                Name: ActionLabels.EDIT,
                Icon: EditIcon,
                OnClick: () => openAddRule(params.data.ID, params.data),
            },
            {
                Name: params.data.Status === ChannelRuleStatus.ACTIVE ? "Disable" : "Enable",
                Icon: params.data.Status === ChannelRuleStatus.ACTIVE ? StopIcon : StartIcon,
                OnClick: params.data.Status === ChannelRuleStatus.IN_ACTIVE ? (e) => handleAutomationEnable(e, params.data.Id) : (e) => handleAutomationDisable(e, params.data.Id)
            },
            {
                Name: ActionLabels.DELETE,
                Icon: TrashIcon,
                OnClick: () => handleChannelDeleteAutomatedReply(params.data.Id),
            },
            ]
            }
                {...params}
            />,
            resizable: false,
            sortable: false,
            hide: IsMobileDevice
        },
    ]

    const refreshData = (successCallBack?: () => void, hideLoader?: boolean) => {
        setIsLoading(!hideLoader);
        if (!!activeChannel && !activeChannel.Active) {
            props.runLoader();
            setRowData([])
            props.count(0)
        }
        else {
            props.runLoader();
            setColumnDefs(ChannelColoumnDefs)
            if (Channels.find(x => x.ID === activeChannel.SubOptions?.find(x => x.Active).ID).Status === ChannelAccountStatus.CONNECTED) {
                ChannelConversationService.getAllAutomatedRepliesByPageId(user.OrganizationID, activeChannel.SubOptions?.find(x => x.Active)?.ID).then((res) => {
                    if (res.data !== null) {
                        setRowData(res.data.map(x => mapToChannelAutomatedReply(x)))
                        props.count(res.data.length)
                        props.refreshData()
                    }
                    else {
                        setRowData([])
                        props.count(0)
                    }
                }).catch(() => { })
            }
            else {
                setRowData([])
                props.count(0)
            }
        }
    }

    const handleSideBarWidth = (number) => {
        setSidebarWidth(number)
    }

    const handleChannelOptions = (ChannelOptions) => {
        let ActiveChannel = ChannelOptions.find(x => x.Active === true)
        setChannelOptions(ChannelOptions)
        setActiveChannel(ActiveChannel)
        props.handleChannel(ActiveChannel.ChannelType)
    }

    return (
        <>
            {
                <div className={`w-p-100 h-p-100 d-flex justify-center align-center  ${IsMobileDevice ? "" : "bg-color-secondary"}`}>
                    <div className="w-p-96 h-p-100 bg-color-side-bar br-3 d-flex o-hidden">
                        <div className={`min-w-${sidebarWidth} d-flex align-center justify-center h-p-96 my-auto ml-2 select-channel-active-border br-2`}>
                            <SelectChannelSideBarComponent Options={channelOptions} handleSidebarWidth={handleSideBarWidth} handleOptions={handleChannelOptions} />
                        </div>
                        {(Channels.length && channelOptions.find(x => x.Active)?.SubOptions.length) ?
                            <div className={`${IsMobileDevice ? "w-p-100" : `flex-1`}  h-p-100 channel-side-bar-icon`}>
                                <GridComponent
                                    ColumnDefs={columnDefs}
                                    RowData={rowData}
                                    OnGridReady={props.onGridReady}
                                    IsPaginationEnabled={false}
                                    EmptyLabel={Channels.find(x => x?.ID === activeChannel.SubOptions.find(x => x.Active)?.ID)?.Status === ChannelAccountStatus.DISCONNECTED ?
                                        (
                                            <div>
                                                <div className='mb-2'><img src={LivechatDisconnectedIcon} alt="" /></div>
                                                <span><Link to={AppRoutes.CHANNELS} className="color-primary-link"> {activeChannel.SubOptions.find(x => x.Active)?.Label}</Link> has been disconnected,Connect the channel to view rules.</span>
                                            </div>
                                        )
                                        : Channels.find(x => x?.ID === activeChannel.SubOptions.find(x => x.Active)?.ID)?.Status === ChannelAccountStatus.VALIDATION_PENDING ?
                                            (
                                                <div>
                                                    <div className='mb-2'><img src={LivechatValidationPendingIcon} alt="" /></div>
                                                    <span><Link to={AppRoutes.CHANNELS} className="color-primary-link"> {activeChannel.SubOptions.find(x => x.Active)?.Label}</Link> validation is pending,Connect the channel to view rules.</span>
                                                </div>
                                            )
                                            : <div>
                                                <div className="mt-8"><ChannelsGridEmptyIcon /></div>
                                                <span className="h5-medium">{emptyLabels.RULES}</span>
                                            </div>}
                                    LockVisible={IsMobileDevice}
                                    gridApi={props.gridApi}
                                />
                            </div>
                            :
                            <div className={`bg-color-secondary flex-1 h-p-96 my-auto mr-2 select-channel-active-border br-2 min-w-60 ml-2`}>
                                <NoDataComponent Message={<div>To set up automation rules, you first need to <span className="color-primary-light mx-1 c-pointer w-space" onClick={() => navigate(AppRoutes.ADD_CHANNELS)}>Add a Channel</span></div>} />
                            </div>
                        }
                    </div>
                </div>
            }
            {
                props.editOption && (
                    <AddRuleComponentChannel OnClose={closeAddRule} Show={editoption} Rule={OperatingRule} ButtonLabel={buttonLabels.SAVE} HandleSubmitSuccess={() => refreshData()} Channel={activeChannel.ChannelType} Page={activeChannel.SubOptions?.find(x => x.Active)?.ID} />
                )
            }
            {
                ShowDeleleConfirmation && (
                    <ConfirmDialog
                        onClose={closeDeleteDialog}
                        Show={ShowDeleleConfirmation}
                        Text={Text}
                        ButtonName={ButtonName}
                        IsMobileDevice={IsMobileDevice}
                        Loading={IsDeleteInProgress}
                    />
                )
            }
        </>
    )

}

export default PrivateRuleComponent;

